export default __webpack_public_path__ + "75ccf963e09a8cc171934af313a343a2.ttf";